import * as yup from 'yup';
import { CellarCoolingStatusType, ManagementType } from '../types';

export const createCellarCoolingDialogSchema = yup.object().shape({
  position: yup.number().required().label('Position'),
  model: yup.string().nullable().default(null).label('Model'),
  status: yup
    .mixed<CellarCoolingStatusType>()
    .oneOf(Object.values(CellarCoolingStatusType))
    .required()
    .label('CellarCoolingStatusType'),
  management: yup.mixed<ManagementType>().oneOf(Object.values(ManagementType)).required().label('ManagementType'),
  description: yup.string().nullable().default(null).label('Description'),
  is24Hours: yup.boolean().default(false).required().label('is24Hours'),
  cellarId: yup.string().required().label('Cellar'),
  shouldShift: yup.boolean().nullable().default(null).label('Should shift')
});

export const updateCellarCoolingDialogSchema = yup.object().shape({
  cellarCoolingId: yup.string().nullable().default(null).label('Cellar Cooling Id'),
  position: yup.number().required().label('Position'),
  model: yup.string().nullable().default(null).label('Model'),
  status: yup
    .mixed<CellarCoolingStatusType>()
    .oneOf(Object.values(CellarCoolingStatusType))
    .required()
    .label('CellarCoolingStatusType'),
  management: yup.mixed<ManagementType>().oneOf(Object.values(ManagementType)).required().label('ManagementType'),
  description: yup.string().nullable().default(null).label('Description'),
  is24Hours: yup.boolean().default(false).required().label('is24Hours'),
  cellarId: yup.string().required().label('Cellar'),
  shouldShift: yup.boolean().nullable().default(null).label('Should shift')
});
